export default __webpack_public_path__ + "static/media/incidents-integrity.fd670066.jpg";